module.exports = __webpack_public_path__ + "static/media/login-logo.ffeaf355.svg";